/*
 * @description: 
 * @author: Jason Wong
 * @since: 2025-03-17 10:58:57
 */
/**
 *
 * @param {Route} router
 */
export function useChunkGuard(router) {
  router.onError((error) => {
    console.error(error, error.message);
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = pattern.test(error.message);
    if (isChunkLoadFailed) {
      location.reload();
    }
  });
}
